module.exports = __webpack_public_path__ + "static/media/straight_line_clamp.e1fbbfd5.webp";